import React, { Component } from 'react';
import WavesIcons from "@material-ui/icons/Waves";
import {Grid,Button} from "@material-ui/core";

class WavesIcon extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            color:"action",
            openAlert:false
         }
         this.handleClick=this.handleClick.bind(this);
    }
    handleClick(){
        if(this.state.color==="primary"){
            this.setState({
                color:"action"
            })
        }
        else{
            this.setState({
                color:"primary",
                openAlert:true
            })
            var dummy = document.createElement('input'),
        text = window.location.href;
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
        }
    }
    render() { 
        return ( 
            <Grid>
                <div>
            <div><WavesIcons color={this.state.color} onClick={this.handleClick}></WavesIcons></div>
            {(this.state.openAlert)?
            <div><Button onClick={()=>{this.setState({openAlert:false})}} variant="outlined">LINK COPIED TO CLIPBOARD</Button></div>:null}
            </div>
            </Grid>
         );
    }
}
 
export default WavesIcon;


// WEBPACK FOOTER //
// ./src/components/VIEW/WavesIcon.js